'use client'

import { Box, Grid, Heading, List, ListItem, Text, Icon, VStack } from '@chakra-ui/react'
import { ContentContainer } from 'ui'
import { FC } from 'react'
import { SectionLabel, SectionTitle } from '../_components/granditude'
import { FaTimes, FaCheck } from 'react-icons/fa'

const notFit = [
  'You want a simple setup with no plans to grow',
  "You're looking for the cheapest option",
  'You prefer manual work over automation',
  "You're okay being limited by your tools"
]

const yesFit = [
  'Your operations are messy and interconnected',
  "You've tried other solutions that didn't work out",
  'You want a partner, not just a vendor',
  'You value doing it right, not just doing it'
]

export const FitSection: FC = () => {
  return (
    <Box as="section" w="100%" py={{ base: 16, md: 32 }}>
      <ContentContainer>
        <VStack align="start" spacing={0} w="100%">
          <SectionLabel>Honest Talk</SectionLabel>
          <SectionTitle>We&apos;re not for everyone</SectionTitle>

          <Grid templateColumns={{ base: '1fr', md: '1fr 1fr' }} gap={10} mt={10} w="100%">
            <Box>
              <Heading
                as="h3"
                fontFamily="heading"
                fontSize="1.3rem"
                fontWeight={500}
                mb={6}
                color="text.secondary"
              >
                Probably not the right fit if:
              </Heading>
              <List spacing={3}>
                {notFit.map((item, index) => (
                  <ListItem
                    key={index}
                    display="flex"
                    alignItems="flex-start"
                    gap={2}
                    color="text.secondary"
                  >
                    <Icon as={FaTimes} w={4} h={4} mt={1} color="gray.400" flexShrink={0} />
                    <Text>{item}</Text>
                  </ListItem>
                ))}
              </List>
            </Box>

            <Box>
              <Heading
                as="h3"
                fontFamily="heading"
                fontSize="1.3rem"
                fontWeight={500}
                mb={6}
                color="teal.500"
              >
                We&apos;re a good fit if:
              </Heading>
              <List spacing={3}>
                {yesFit.map((item, index) => (
                  <ListItem
                    key={index}
                    display="flex"
                    alignItems="flex-start"
                    gap={2}
                    color="text.secondary"
                  >
                    <Icon as={FaCheck} w={4} h={4} mt={1} color="teal.500" flexShrink={0} />
                    <Text>{item}</Text>
                  </ListItem>
                ))}
              </List>
            </Box>
          </Grid>
        </VStack>
      </ContentContainer>
    </Box>
  )
}
